import styled from 'styled-components';
import Link from '@nubank/nuds-web/components/Link/Link';

export const StyledLink = styled(Link)`
  margin-top: 2rem;
`;

StyledLink.displayName = 'StyledLink';
